module.exports = __webpack_public_path__ + "static/media/animated-1.0f8fd9cc.gif";